module.exports = __webpack_public_path__ + "assets/img/kf.755ffda4.jpg";